import { Checkbox } from "@mui/material"
import { FC, useMemo, useState } from "react"
import { markCompanyRequestAsResolved } from "src/apis/company_requests"
import { isUserAdministrator } from "src/utils/auth"
import { Id } from "src/utils/types"

type CompanyRequestsTableResolvedCellProps = {
  companyRequestId: Id,
  resolved: boolean,
  setError: (err: string) => void,
}

const CompanyRequestsTableResolvedCell: FC<CompanyRequestsTableResolvedCellProps> = ({
  companyRequestId,
  resolved,
  setError,
}) => {
  const [checked, setChecked] = useState<boolean>(resolved);

  const isAdmin = useMemo<boolean>(() => isUserAdministrator(), []);

  const resolve = async () => {
    try {
      await markCompanyRequestAsResolved(companyRequestId);

      setError('');
      setChecked(true);
    } catch(err: any) {
      setError(err.error);
    }
  }

  return (
    <Checkbox
      disabled={!isAdmin}
      checked={checked}
      title={isAdmin ? "Marcar como resolvido" : "Resolvido?"}
      onClick={() => {
        if (window.confirm("Deseja mesmo marcar essa solicitação como resolvida? Esse processo é irreversível.")) {
          resolve();
        }
      }}/>
  )
}

export default CompanyRequestsTableResolvedCell;
